import React, { useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { showMessage } from "../../Functionalities/Functions";
import confirmBox from "../../CoreComponents/confirmBox";
import { fmtDate, rupees } from "../Insights/format";
import PaymentsTable from "./PaymentsTable";
import { standingLine } from "./riderReportData";
import PaymentForm from "./PaymentForm";
import { deletePayment, fetchPayments } from "./riderPaymentsData";

export default function RiderPayments({ riderId, range, onChanged }) {
  const [data, setData] = useState({ rows: [], summary: null });
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let live = true;
    setLoading(true);
    fetchPayments({ riderId, range }).then((result) => {
      if (!live) return;
      setData(result);
      setLoading(false);
    });
    return () => {
      live = false;
    };
  }, [riderId, range, version]);

  const changed = () => {
    setAdding(false);
    setVersion((v) => v + 1);
    onChanged();
  };

  const remove = (payment) =>
    confirmBox({
      title: "Delete this payment?",
      message: `${rupees(payment.amount)} paid on ${fmtDate(payment.paid_on)}. The rider holds that cash again.`,
      yesLabel: "Delete",
      noLabel: "Cancel",
      onYes: () => removeConfirmed(payment),
    });

  const removeConfirmed = async (payment) => {
    const body = await deletePayment(payment.id);
    if (body.Status !== true) {
      showMessage(body.Error || "The payment was not deleted", "danger", "Not deleted", "top", "top-right");
      return;
    }
    changed();
  };

  const { rows, summary } = data;

  return (
    <div className="stl-card stl-table-card">
      <div className="stl-table-bar">
        <div className="stl-table-bar__title">
          <h2 className="stl-title">Previous settlements</h2>
          <span className="stl-subtitle">
            {rows.length} payment{rows.length === 1 ? "" : "s"}
            {summary ? ` · ${standingLine(summary)}` : ""}
          </span>
        </div>
        {!adding && (
          <button type="button" className="stl-btn stl-btn--sm stl-btn--primary" onClick={() => setAdding(true)}>
            <PlusOutlined /> Record payment
          </button>
        )}
      </div>
      {adding && <PaymentForm riderId={riderId} onSaved={changed} onCancel={() => setAdding(false)} />}
      <PaymentsTable rows={rows} loading={loading} onDelete={remove} />
    </div>
  );
}
